import { useState } from "react";
import classNames from 'classnames';
import ButtonRip from "./ripple/button";

export default function Nav() {
    const [navbar, setNavbar] = useState(false);

    return (
        <nav className="w-full shadow">
            <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
                <div>
                    <div className="flex  items-center justify-between py-3 md:py-5 md:block">
                        <a href="#home">
                            <h2 className="text-2xl font-bold text-white cursive">
                                &#60; Janhavi       &#47;&#62;
                            </h2>
                        </a>
                        <div className="md:hidden">
                            <button
                                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border z-50"
                                onClick={() => setNavbar(!navbar)}
                            >
                                {navbar ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6 text-white z-50"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6 text-white z-50"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className={classNames(
                            'md:block',
                            {
                                'absolute top-7 right-0 w-full h-screen bg-black z-50 flex justify-end': navbar,
                                'hidden': !navbar,
                            }
                        )}
                    >
                        <ul className="nav-o items-center justify-center space-x-1 md:flex md:space-x-6 md:space-y-0">
                            <li className={classNames("text-white hover:text-indigo-200 lg:py-4 px-1 border-b-4 lg:pr-28  font-medium", "li-2")}>
                                <a href="#Home" className="js-anchor-link">
                                    <ButtonRip>
                                        Home
                                    </ButtonRip>
                                </a>
                            </li>
                            <li className={classNames("text-white hover:text-indigo-200 lg:py-4 px-1 border-b-4 lg:pr-28  font-medium", "li-2")}>
                                <a href="#About" className="js-anchor-link">
                                    <ButtonRip>
                                        About Me
                                    </ButtonRip>
                                </a>
                            </li>
                            <li className={classNames("text-white hover:text-indigo-200 lg:py-4 px-1 border-b-4 lg:pr-28  font-medium ", "li-2")}>
                                <a href="#Project" className="js-anchor-link">
                                    <ButtonRip>
                                        Projects
                                    </ButtonRip>
                                </a>
                            </li>
                            <li className={classNames("text-white hover:text-indigo-200 lg:py-4 px-1 border-b-4 lg:pr-28  font-medium ", "li-2")}>
                                <a href="#Skills" className="js-anchor-link">
                                    <ButtonRip>
                                        Skills
                                    </ButtonRip>
                                </a>
                            </li>
                            <li className={classNames("text-white hover:text-indigo-200 lg:py-4 px-1 border-b-4 lg:pr-28  font-medium ", "li-2")}>

                                <a href="https://docs.google.com/document/d/1usGxkx7Om7PMo1EO8PM5wUSdniwl78MB1AEll3Aq-W4/edit?usp=sharing" target="_blank" rel="noopener noreferrer" >
                                    <ButtonRip>
                                        Resume
                                    </ButtonRip>
                                </a>
                            </li>
                            <li onClick={() => setNavbar(!navbar)} className="text-white hover:text-indigo-200 lg:py-4 px-1 border-b-4 lg:pr-28  font-medium">
                                <a href="#Contact" className="js-anchor-link">
                                    <ButtonRip>
                                        Contact
                                    </ButtonRip>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
}
